import * as Types from '../../../generated/webapp_gql';

import { gql } from 'graphql.macro';
import * as React from 'react';
import * as ApolloReactCommon from '@apollo/react-common';
import * as ApolloReactComponents from '@apollo/react-components';
import * as ApolloReactHoc from '@apollo/react-hoc';
import * as ApolloReactHooks from '@apollo/react-hooks';
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
const defaultOptions =  {}
export type ProgramPreviewFragment = (
  { __typename?: 'ProgramNode' }
  & Pick<Types.ProgramNode, 'id' | 'uuid' | 'createdAt' | 'updatedAt' | 'name' | 'category' | 'image' | 'duration' | 'slug' | 'isCompleted'>
);

export type ProgramPageFragment = (
  { __typename?: 'PageNode' }
  & Pick<Types.PageNode, 'id' | 'createdAt' | 'updatedAt' | 'name' | 'number' | 'type' | 'content' | 'image' | 'answerOptions' | 'firstBackgroundImagePosition' | 'firstBackgroundImageUrl' | 'secondBackgroundImagePosition' | 'secondBackgroundImageUrl' | 'contentVerticalAlignment' | 'contentHorizontalAlignment' | 'multiselectConfig' | 'audioFile'>
  & { pageProgress: Array<(
    { __typename?: 'PageProgressNode' }
    & Pick<Types.PageProgressNode, 'id' | 'input' | 'completedAt'>
  )>, currentPageProgress?: Types.Maybe<(
    { __typename?: 'PageProgressNode' }
    & { parsedInput?: Types.Maybe<Array<(
      { __typename?: 'UserInput' }
      & Pick<Types.UserInput, 'optionValue' | 'textValue'>
    )>> }
  )>, parsedAnswerOptions?: Types.Maybe<Array<(
    { __typename?: 'AnswerOption' }
    & Pick<Types.AnswerOption, 'text' | 'isSelected' | 'customOptionValue'>
    & { customOptions?: Types.Maybe<(
      { __typename?: 'AnswerCustomOptions' }
      & Pick<Types.AnswerCustomOptions, 'title' | 'placeholder' | 'buttonText'>
    )> }
  )>>, parsedMultiselectConfig?: Types.Maybe<(
    { __typename?: 'MultiselectConfig' }
    & Pick<Types.MultiselectConfig, 'minSelectable' | 'maxSelectable'>
  )>, videoContent?: Types.Maybe<(
    { __typename?: 'VideoContentNode' }
    & Pick<Types.VideoContentNode, 'source' | 'textTrack' | 'poster'>
  )> }
);

export type ProgramFragment = (
  { __typename?: 'ProgramNode' }
  & Pick<Types.ProgramNode, 'showRatings'>
  & { nextProgram?: Types.Maybe<(
    { __typename?: 'ProgramNode' }
    & Pick<Types.ProgramNode, 'name' | 'category'>
  )>, pages: Array<(
    { __typename?: 'PageNode' }
    & ProgramPageFragment
  )> }
  & ProgramPreviewFragment
);

export type GetProgramQueryVariables = Types.Exact<{
  uuid: Types.Scalars['UUID'];
}>;


export type GetProgramQuery = (
  { __typename?: 'Query' }
  & { program?: Types.Maybe<(
    { __typename?: 'ProgramNode' }
    & Pick<Types.ProgramNode, 'id' | 'uuid'>
    & ProgramPreviewFragment
  )> }
);

export type GetProgramWithPagesBySlugQueryVariables = Types.Exact<{
  slug: Types.Scalars['String'];
}>;


export type GetProgramWithPagesBySlugQuery = (
  { __typename?: 'Query' }
  & { programBySlug?: Types.Maybe<(
    { __typename?: 'ProgramNode' }
    & Pick<Types.ProgramNode, 'id' | 'uuid'>
    & ProgramFragment
  )> }
);

export type GetProgramWithPagesQueryVariables = Types.Exact<{
  uuid: Types.Scalars['UUID'];
}>;


export type GetProgramWithPagesQuery = (
  { __typename?: 'Query' }
  & { program?: Types.Maybe<(
    { __typename?: 'ProgramNode' }
    & Pick<Types.ProgramNode, 'id' | 'uuid'>
    & ProgramFragment
  )> }
);

export const ProgramPreviewFragmentDoc = gql`
    fragment ProgramPreview on ProgramNode {
  id
  uuid
  createdAt
  updatedAt
  name
  category
  image
  duration
  slug
  isCompleted @client
}
    `;
export const ProgramPageFragmentDoc = gql`
    fragment ProgramPage on PageNode {
  id
  createdAt
  updatedAt
  name
  number
  type
  content
  image
  answerOptions
  pageProgress {
    id
    input
    completedAt
  }
  firstBackgroundImagePosition
  firstBackgroundImageUrl
  secondBackgroundImagePosition
  secondBackgroundImageUrl
  contentVerticalAlignment
  contentHorizontalAlignment
  currentPageProgress @client {
    parsedInput {
      optionValue
      textValue
    }
  }
  parsedAnswerOptions @client {
    text
    isSelected @client
    customOptionValue @client
    customOptions {
      title
      placeholder
      buttonText
    }
  }
  multiselectConfig
  parsedMultiselectConfig @client {
    minSelectable
    maxSelectable
  }
  audioFile
  videoContent {
    source
    textTrack
    poster
  }
}
    `;
export const ProgramFragmentDoc = gql`
    fragment Program on ProgramNode {
  ...ProgramPreview
  showRatings
  nextProgram {
    name
    category
  }
  pages {
    ...ProgramPage
  }
}
    ${ProgramPreviewFragmentDoc}
${ProgramPageFragmentDoc}`;
export const GetProgramDocument = gql`
    query getProgram($uuid: UUID!) {
  program(uuid: $uuid) {
    id
    uuid
    ...ProgramPreview
  }
}
    ${ProgramPreviewFragmentDoc}`;
export type GetProgramComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<GetProgramQuery, GetProgramQueryVariables>, 'query'> & ({ variables: GetProgramQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const GetProgramComponent = (props: GetProgramComponentProps) => (
      <ApolloReactComponents.Query<GetProgramQuery, GetProgramQueryVariables> query={GetProgramDocument} {...props} />
    );
    
export type GetProgramProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<GetProgramQuery, GetProgramQueryVariables>
    } & TChildProps;
export function withGetProgram<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  GetProgramQuery,
  GetProgramQueryVariables,
  GetProgramProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, GetProgramQuery, GetProgramQueryVariables, GetProgramProps<TChildProps, TDataName>>(GetProgramDocument, {
      alias: 'getProgram',
      ...operationOptions
    });
};

/**
 * __useGetProgramQuery__
 *
 * To run a query within a React component, call `useGetProgramQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProgramQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProgramQuery({
 *   variables: {
 *      uuid: // value for 'uuid'
 *   },
 * });
 */
export function useGetProgramQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetProgramQuery, GetProgramQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetProgramQuery, GetProgramQueryVariables>(GetProgramDocument, options);
      }
export function useGetProgramLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetProgramQuery, GetProgramQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetProgramQuery, GetProgramQueryVariables>(GetProgramDocument, options);
        }
export type GetProgramQueryHookResult = ReturnType<typeof useGetProgramQuery>;
export type GetProgramLazyQueryHookResult = ReturnType<typeof useGetProgramLazyQuery>;
export type GetProgramQueryResult = ApolloReactCommon.QueryResult<GetProgramQuery, GetProgramQueryVariables>;
export const GetProgramWithPagesBySlugDocument = gql`
    query getProgramWithPagesBySlug($slug: String!) {
  programBySlug(slug: $slug) {
    id
    uuid
    ...Program
  }
}
    ${ProgramFragmentDoc}
${ProgramPreviewFragmentDoc}
${ProgramPageFragmentDoc}`;
export type GetProgramWithPagesBySlugComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<GetProgramWithPagesBySlugQuery, GetProgramWithPagesBySlugQueryVariables>, 'query'> & ({ variables: GetProgramWithPagesBySlugQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const GetProgramWithPagesBySlugComponent = (props: GetProgramWithPagesBySlugComponentProps) => (
      <ApolloReactComponents.Query<GetProgramWithPagesBySlugQuery, GetProgramWithPagesBySlugQueryVariables> query={GetProgramWithPagesBySlugDocument} {...props} />
    );
    
export type GetProgramWithPagesBySlugProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<GetProgramWithPagesBySlugQuery, GetProgramWithPagesBySlugQueryVariables>
    } & TChildProps;
export function withGetProgramWithPagesBySlug<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  GetProgramWithPagesBySlugQuery,
  GetProgramWithPagesBySlugQueryVariables,
  GetProgramWithPagesBySlugProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, GetProgramWithPagesBySlugQuery, GetProgramWithPagesBySlugQueryVariables, GetProgramWithPagesBySlugProps<TChildProps, TDataName>>(GetProgramWithPagesBySlugDocument, {
      alias: 'getProgramWithPagesBySlug',
      ...operationOptions
    });
};

/**
 * __useGetProgramWithPagesBySlugQuery__
 *
 * To run a query within a React component, call `useGetProgramWithPagesBySlugQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProgramWithPagesBySlugQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProgramWithPagesBySlugQuery({
 *   variables: {
 *      slug: // value for 'slug'
 *   },
 * });
 */
export function useGetProgramWithPagesBySlugQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetProgramWithPagesBySlugQuery, GetProgramWithPagesBySlugQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetProgramWithPagesBySlugQuery, GetProgramWithPagesBySlugQueryVariables>(GetProgramWithPagesBySlugDocument, options);
      }
export function useGetProgramWithPagesBySlugLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetProgramWithPagesBySlugQuery, GetProgramWithPagesBySlugQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetProgramWithPagesBySlugQuery, GetProgramWithPagesBySlugQueryVariables>(GetProgramWithPagesBySlugDocument, options);
        }
export type GetProgramWithPagesBySlugQueryHookResult = ReturnType<typeof useGetProgramWithPagesBySlugQuery>;
export type GetProgramWithPagesBySlugLazyQueryHookResult = ReturnType<typeof useGetProgramWithPagesBySlugLazyQuery>;
export type GetProgramWithPagesBySlugQueryResult = ApolloReactCommon.QueryResult<GetProgramWithPagesBySlugQuery, GetProgramWithPagesBySlugQueryVariables>;
export const GetProgramWithPagesDocument = gql`
    query getProgramWithPages($uuid: UUID!) {
  program(uuid: $uuid) {
    id
    uuid
    ...Program
  }
}
    ${ProgramFragmentDoc}
${ProgramPreviewFragmentDoc}
${ProgramPageFragmentDoc}`;
export type GetProgramWithPagesComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<GetProgramWithPagesQuery, GetProgramWithPagesQueryVariables>, 'query'> & ({ variables: GetProgramWithPagesQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const GetProgramWithPagesComponent = (props: GetProgramWithPagesComponentProps) => (
      <ApolloReactComponents.Query<GetProgramWithPagesQuery, GetProgramWithPagesQueryVariables> query={GetProgramWithPagesDocument} {...props} />
    );
    
export type GetProgramWithPagesProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<GetProgramWithPagesQuery, GetProgramWithPagesQueryVariables>
    } & TChildProps;
export function withGetProgramWithPages<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  GetProgramWithPagesQuery,
  GetProgramWithPagesQueryVariables,
  GetProgramWithPagesProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, GetProgramWithPagesQuery, GetProgramWithPagesQueryVariables, GetProgramWithPagesProps<TChildProps, TDataName>>(GetProgramWithPagesDocument, {
      alias: 'getProgramWithPages',
      ...operationOptions
    });
};

/**
 * __useGetProgramWithPagesQuery__
 *
 * To run a query within a React component, call `useGetProgramWithPagesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProgramWithPagesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProgramWithPagesQuery({
 *   variables: {
 *      uuid: // value for 'uuid'
 *   },
 * });
 */
export function useGetProgramWithPagesQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetProgramWithPagesQuery, GetProgramWithPagesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetProgramWithPagesQuery, GetProgramWithPagesQueryVariables>(GetProgramWithPagesDocument, options);
      }
export function useGetProgramWithPagesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetProgramWithPagesQuery, GetProgramWithPagesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetProgramWithPagesQuery, GetProgramWithPagesQueryVariables>(GetProgramWithPagesDocument, options);
        }
export type GetProgramWithPagesQueryHookResult = ReturnType<typeof useGetProgramWithPagesQuery>;
export type GetProgramWithPagesLazyQueryHookResult = ReturnType<typeof useGetProgramWithPagesLazyQuery>;
export type GetProgramWithPagesQueryResult = ApolloReactCommon.QueryResult<GetProgramWithPagesQuery, GetProgramWithPagesQueryVariables>;